import { Box, Button, Flex, Heading, SimpleGrid, Stack, Text, VStack } from "@chakra-ui/react";
import React from "react";
import { Link } from "react-router-dom";
import { FiGift, FiShield, FiCheckCircle } from "react-icons/fi";

const STEPS = [
  { icon: FiGift, title: "Za darmo", text: "Bez opłat i ukrytych kosztów — dla każdej organizacji i społeczności." },
  { icon: FiShield, title: "Bezpiecznie", text: "Kryptografia i blockchain chronią każdy oddany głos przed manipulacją." },
  { icon: FiCheckCircle, title: "Wiarygodnie", text: "Wyniku nie da się podmienić, a każdy może samodzielnie go zweryfikować." }
];

export const OrganizerCTA: React.FC = () => (
  <Box w="100%" maxW="1240px" mx="auto" px={{ base: "24px", md: "32px" }} py={{ base: "40px", md: "64px" }}>
    <Box
      bgGradient="linear(135deg, #430098 0%, #5a0bbf 100%)"
      borderRadius="28px"
      p={{ base: "32px", md: "56px" }}
      boxShadow="0 24px 60px rgba(67,0,152,0.25)"
    >
      <VStack spacing="14px" textAlign="center" mb={{ base: "32px", md: "44px" }}>
        <Heading fontSize={{ base: "28px", md: "40px" }} color="background" fontWeight="800" letterSpacing="-0.02em">
          Zorganizuj własne głosowanie
        </Heading>
        <Text fontSize={{ base: "16px", md: "19px" }} color="rgba(255,250,235,0.88)" maxW="640px">
          Reprezentujesz organizację lub społeczność i chcecie podjąć decyzję wspólnie?
          Stwórz głosowanie, zaproś uprawnionych i miej pewność, że wynik jest nie do podważenia.
        </Text>
      </VStack>

      <SimpleGrid columns={{ base: 1, md: 3 }} spacing={{ base: "16px", md: "24px" }} mb={{ base: "32px", md: "44px" }}>
        {STEPS.map(s => (
          <VStack
            key={s.title}
            align="flex-start"
            spacing="12px"
            bg="rgba(255,255,255,0.08)"
            border="1px solid rgba(255,255,255,0.14)"
            borderRadius="18px"
            p="24px"
          >
            <Flex w="48px" h="48px" align="center" justify="center" bg="accent" borderRadius="14px">
              <s.icon size={23} color="#FFFAEB" />
            </Flex>
            <Heading fontSize="20px" color="background">
              {s.title}
            </Heading>
            <Text fontSize="14px" lineHeight="21px" color="rgba(255,250,235,0.82)">
              {s.text}
            </Text>
          </VStack>
        ))}
      </SimpleGrid>

      <Stack direction={{ base: "column", sm: "row" }} spacing="14px" justify="center">
        <Button
          as={Link}
          to="/rejestracja"
          h="auto"
          py="16px"
          px="32px"
          bg="accent"
          color="white"
          fontSize="16px"
          fontWeight="700"
          borderRadius="14px"
          boxShadow="0 12px 28px rgba(229,31,68,0.35)"
          _hover={{ bg: "#c41a3a", transform: "translateY(-1px)" }}
          transition="all 0.15s"
        >
          Zarejestruj się
        </Button>
        <Button
          as={Link}
          to="/logowanie"
          h="auto"
          py="16px"
          px="32px"
          bg="rgba(255,255,255,0.10)"
          color="background"
          fontSize="16px"
          fontWeight="700"
          borderRadius="14px"
          borderWidth="1.5px"
          borderColor="rgba(255,255,255,0.4)"
          _hover={{ bg: "rgba(255,255,255,0.2)" }}
        >
          Mam już konto
        </Button>
      </Stack>
    </Box>
  </Box>
);
